import { Outlet } from "@tanstack/react-router";
import Footer from "./components/footer";
import Navbar from "./components/navbar";
import Signup from "./components/signup";
import { useApplyTheme } from "./hooks/useApplyTheme";
import "./index.css";

export function App() {
  useApplyTheme();

  return (
    <div className="app">
      <Navbar />
      <main>
        <Outlet />
      </main>

      <Signup />
      <Footer />
    </div>
  );
}

export default App;
